import { render, staticRenderFns } from "./CustomerGroupDetail.vue?vue&type=template&id=79bbb867"
import script from "./CustomerGroupDetail.vue?vue&type=script&lang=js"
export * from "./CustomerGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroupDetail.vue?vue&type=style&index=0&id=79bbb867&prod&lang=scss"
import style1 from "./CustomerGroupDetail.vue?vue&type=style&index=1&id=79bbb867&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports